/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteTemplate.defs.js'
export { main as default } from './deleteTemplate.defs.js'
